// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"c97a62cf","201":"32609542","388":"3304b8d4","402":"cec2fadf","814":"935addeb","902":"ccb6c119"}[chunkId] + ".chunk.css";
};